const wizardForm = [
    {
        selector: '[data-wizard-form=""]',
        path: { filename: 'wizardForm' },
    },
];

export { wizardForm };
